/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useRef } from 'react'
import { FormikProps } from 'formik'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'

import CloseAccountForm from 'containers/account/form/closeAccountForm'
import { useAppSelector } from 'store/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function CloseAccountLightbox({ status, close }: Props) {
    const formRef = useRef<FormikProps<{ confirm_termination: boolean, password: string, confirm_password: string }>>(null)
    const { appSettings: { provider: { provider_name, application_name } } } = useAppSelector((state) => state.app)

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            title={'Close Account'}
            description={`
                Completing this action will remove all access you currently have to ${application_name} 
                and ordering services via the ${provider_name} website. 
                You will no longer receive emails relating to your account if you process this account closure.
            `}
            content={<CloseAccountForm form={formRef} />}
            conditions={{ state: status, action: () => close() }}
            actions={[
                {
                    label: 'Back',
                    color: 'secondary',
                    func: () => {
                        close()
                    }
                },
                {
                    label: 'Permanently Close Account',
                    type: 'submit',
                    color: 'error',
                    loading: formRef?.current?.isSubmitting ? 'Submitting Request...' : false,
                    func: () => formRef?.current?.handleSubmit()
                }
            ]}
        />
    )
}
